import PropTypes from "prop-types";

export const Header = ({ ctx, uiState }) => {
  const { title, tooltip, } = ctx || {};
  const { isHeaderTitleHighlighted = false, headerFontSize } = uiState || {};

  const fontSize = headerFontSize ? headerFontSize : "0.7rem";

  return (
    <div title={tooltip}>
      <span style={{ display: 'inline-block', margin: '0 0 0.3rem 0', fontSize: fontSize, color: `${isHeaderTitleHighlighted ? "red" : ""}` }}>{title[0]}</span>
      <br />
      <span style={{ fontSize: "0.7rem", color: `${isHeaderTitleHighlighted ? "red" : ""}` }}>{title[1] ?? ""}</span>
    </div>    
  )
};

Header.propTypes = { ctx: PropTypes.shape(), uiState: PropTypes.shape() };